import type { EventRoute } from '@/shared/infrastructure/events/eventRouter';
import { printingKeys } from './queryKeys';

export function registerPrintingEvents(
  register: (eventType: string, route: EventRoute) => void,
): void {
  register('printing.order.status-changed', {
    getQueryKeys: (p) => [
      printingKeys.order(p.orderId as string),
      printingKeys.orders(p.familyId as string),
    ],
  });
}
